import React from "react"

const SensorsPage = () => {
	return <div>SensorsPage</div>
}

export default SensorsPage
